exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".geelyNoticeDetailBox h1 {\n  margin: 0;\n  color: #333333;\n  font-size: 0.18rem;\n  padding: 0.12rem;\n}\n.geelyNoticeDetailBox .source {\n  padding: 0.08rem 0.12rem 0.12rem 0.12rem;\n  color: #999;\n  font-size: 0.14rem;\n  line-height: 1.6;\n  letter-spacing: 0.01rem;\n  margin-bottom: 0.08rem;\n  border-bottom: 1px solid #EBEBEB;\n}\n.geelyNoticeDetailBox .source span {\n  margin-right: 0.16rem;\n}\n.geelyNoticeDetailBox .source .author {\n  font-weight: bold;\n  color: #10C2B0;\n}\n.geelyNoticeDetailBox .content {\n  font-size: 0.14rem;\n  letter-spacing: 0.014rem;\n  line-height: 2.2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/geelyNotice/detail/index.less
// module id = 1023
// module chunks = 0